import { Injectable } from '@angular/core';
import { IExecutionContext } from '../flow/interfaces/iexecution-context';

@Injectable()
export class ExecutionContext implements IExecutionContext {

  //public communicatorFactory: IRoomsManager;
  public debugView: any;//debug-only, to show progress, etc. on the node itself.
}
